

































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Session } from '../../utils/Session';
import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';
import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { dayjs, DT_FORMAT_INPUT } from '../../../src_server/common/momentExtends';
import EmergencyMessageDialog from '../../components/messages/EmergencyMessageDialog.vue';
import { MessageDialog } from '../../utils/MessageDialog';
import TransferDialog from '../components/TransferDialog.vue';
import { routeHelper } from '../../utils/routeHelper';
import TeacherLessonStatusRow from './TeacherLessonStatusRow.vue';

class LessonByStudent {
  student_user_id = '';
  student_nickname = '';
  lessonsDto: LessonDTO[] = [];
}
@Component({
  components: {
    EmergencyMessageDialog,
    TeacherLessonStatusRow,
    TransferDialog,
  },
})
export default class TeacherDashboardPage extends Vue {
  private lessons: any[] = [];
  private lessonsDto: LessonDTO[] = [];
  private month = dayjs().format('YYYY-MM');

  /**
   * データを表示用に変換する
   */
  private get model(): LessonByStudent[] {
    // 日付でソート
    const sorted = this.lessonsDto.sort((a, b) => {
      return dayjs(a.lessons?.start_dt).diff(dayjs(b.lessons?.start_dt));
    });

    // ユーザーごとにまとめつつ、直近のレッスンをマークする
    const grouped = sorted.reduce((pre: LessonByStudent[], cur: LessonDTO): LessonByStudent[] => {
      // 登録済みならマージ
      const found = pre.find((item) => item.student_user_id === cur.student?.user_id);
      if (found) {
        found.lessonsDto.push(cur);
      } else {
        const newData = new LessonByStudent();
        newData.student_user_id = cur.student?.user_id || '';
        newData.student_nickname = cur.student?.nickname || '';
        newData.lessonsDto.push(cur);
        pre.push(newData);
      }
      return pre;
    }, []);
    const result = grouped.map((g) => {
      const recent = g.lessonsDto.find((dto) => {
        console.log(dto.lessons.start_dt);
        return dayjs(dto.lessons.start_dt).diff(dayjs(), 'date') > 0;
      });
      // 直近のレッスンをマーク(当月のみ)
      if (recent && this.month === dayjs().format('YYYY-MM')) {
        recent.isRecent = true;
      }
      return g;
    });

    return result;
  }

  @Watch('month')
  async loadData() {
    const user = Session.get<UserAuthDTO>('USER');
    if (!user || !user.user_id) return;
    const from = dayjs(this.month).startOf('month');
    const to = from.endOf('month');
    const lessonService = new LessonsService();
    const res = await lessonService.getLessonsBetweenByTeacher(Session.getSessionUserId(), from.format(DT_FORMAT_INPUT), to.format(DT_FORMAT_INPUT));
    this.lessonsDto = res.data;
  }

  /**
   * 生成時ライフサイクルメソッド
   */
  async created() {
    await this.loadData();
  }

  /**
   * 緊急メッセージダイアログを表示
   */
  async message(lesson: LessonDTO) {
    const dialog: EmergencyMessageDialog = this.$refs['emergency_message_dialog'] as EmergencyMessageDialog;
    await dialog.show(lesson.lessons.class_id!);
  }

  /**
   * 日報表示
   */
  gotoDailyReport(dto: LessonDTO) {
    if (!dto.lessons.class_id) {
      MessageDialog.systemError('レッスンID', '日報への遷移時', dto.lessons.class_id).then();
      return;
    }
    routeHelper(this, 'TeacherDailyReportPage', { class_id: dto.lessons.class_id.toString() });
  }

  /**
   * カレンダービューに変更
   */
  toCalendarView() {
    routeHelper(this, 'TeacherLessonStateCalendarPage');
  }

  /**
   * 振替のダイアログを表示
   */
  async transfer(row: LessonDTO) {
    const dialog: TransferDialog = this.$refs['taransfer_dialog'] as TransferDialog;
    const dt = row.lessons?.start_dt || new Date();
    await dialog.show(dt, row);
  }
}
